import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Modal,
} from "react-bootstrap";
import PageTitle from "../components/common/PageTitle";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";

import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import api from "../api/api";
import swal from "sweetalert";
import Pagination from "../views/Pagination";
import { Line } from "react-chartjs-2";
import "./ConfigurationManagement.css";

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const ConfigurationCropsVariety = () => {
  const [cropsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [SearchName, setSearchName] = useState("");
  const [allCrops, setAllCrops] = useState([]);
  const [allVarieties, setAllVarieties] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [toggleEdit, setToggleEdit] = useState(false);
  const [singleCrop, setSingleVariety] = useState({});
  const [resultCalculKc, setResultCalculKc] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [fieldRows, setFieldRows] = useState([]);
  const [daysWarning, setDaysWarning] = React.useState("");
  const [displayDate, setDisplayDate] = useState("");

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const { t } = useTranslation();
  const [varietyData, setVarietyData] = useState({
    crop: "",
    cropVariety: "",
    init: "",
    dev: "",
    mid: "",
    late: "",
    rootMin: "",
    rootMax: "",
    kcInit: "",

    kcMid: "",
    kcLate: "",
    allKcList: [],
    varietyAr: "",
    varietyEn: "",
    varietyPhoto: "",
    temperature_chaleur: "",
    temperature_froid: "",
    nb_heure_froid: "",
    nb_heure_chaleur: "",
  });

  const chartData = {
    labels: varietyData?.allKcList?.map((item) => `Day ${item.day}`),
    datasets: [
      {
        label: "Kc",
        data: varietyData?.allKcList?.map((item) => parseFloat(item.kc)),
        fill: false,
        pointRadius: 0,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.3,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: t("Kc_Evolution_by_Day"),
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Days",
        },
      },
      y: {
        title: {
          display: true,
          text: "Kc",
        },
        min: 0,
        max: 1.2,
      },
    },
  };
  const columns = [
    { field: "fieldId", headerName: t("Field ID"), width: 130 },
    { field: "name", headerName: t("Field Name"), flex: 1 },
    { field: "status", headerName: t("Status"), width: 160 },
  ];

  const getCrops = async () => {
    try {
      await api
        .get("/crops/get-crops")
        .then((response) => {
          if (response.data.type === "success") {
            let listCrops = response.data.Crops;
            setAllCrops(listCrops);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const getVarieties = async () => {
    try {
      await api
        .get("/varieties/get-varieties")
        .then((response) => {
          if (response.data.type === "success") {
            let listVarieties = response.data.Varieties;
            setAllVarieties(listVarieties);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCrops();
    getVarieties();
  }, []);

  const getSingleVariety = (varietyId, title) => {
    let data = {
      variety_id: varietyId,
    };
    const formatDate = (dateString) => {
      return dateString ? dateString.slice(0, 10) : "";
    };
    api
      .post("/varieties/get-variety", data)
      .then((res) => {
        let dataVarieties = res.data.variety;

        setSingleVariety(dataVarieties);

        setVarietyData({
          cropVariety: dataVarieties.crop_variety,
          init: dataVarieties.init,
          dev: dataVarieties.dev,
          mid: dataVarieties.mid,
          late: dataVarieties.late,
          rootMin: dataVarieties.root_min,
          rootMax: dataVarieties.root_max,
          kcInit: dataVarieties.kc_init,
          plant_date: formatDate(dataVarieties.plant_date),
          kcMid: dataVarieties.kc_mid,
          kcLate: dataVarieties.kc_late,
          allKcList: dataVarieties.all_kc,
          varietyAr: dataVarieties.variety_ar,
          varietyEn: dataVarieties.variety_en,
          temperature_chaleur: dataVarieties.temperature_chaleur,
          temperature_froid: dataVarieties.temperature_froid,
          nb_heure_froid: dataVarieties.nb_heure_froid,
          nb_heure_chaleur: dataVarieties.nb_heure_chaleur,
        });
        if (title === "Edit") {
          setToggleEdit(!toggleEdit);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const addVarieties = () => {
    const initDays = parseFloat(varietyData.init) || 0;
    const devDays = parseFloat(varietyData.dev) || 0;
    const midDays = parseFloat(varietyData.mid) || 0;
    const lateDays = parseFloat(varietyData.late) || 0;

    const totalDays = initDays + devDays + midDays + lateDays;

    // Check if total days exceed 365
    if (totalDays > 365) {
      swal(t("error"), t("total_stage_days_error"), "error");
      return; // Stop submission
    }
    const datePattern = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])$/;
    if (!displayDate || !datePattern.test(displayDate)) {
      toast.error(t("invalid_date_format"));
      return;
    }
    const areKcAndPeriodsValid = [
      varietyData.init,
      varietyData.dev,
      varietyData.mid,
      varietyData.late,
      varietyData.kcInit,
      varietyData.kcMid,
      varietyData.kcLate,
    ].every((val) => val !== "" && !isNaN(parseFloat(val)));
    let data = {
      crop_id: varietyData.crop,
      crop_variety: varietyData.cropVariety,
      init: varietyData.init,
      dev: varietyData.dev,
      mid: varietyData.mid,
      late: varietyData.late,
      kc_init: varietyData.kcInit,
      kc_mid: varietyData.kcMid,
      kc_late: varietyData.kcLate,
      root_max: varietyData.rootMax,
      root_min: varietyData.rootMin,
      plant_date: varietyData.plant_date,
      all_kc: areKcAndPeriodsValid ? resultCalculKc : [],
      temperature_chaleur: varietyData.temperature_chaleur,
      temperature_froid: varietyData.temperature_froid,
      nb_heure_froid: varietyData.nb_heure_froid,
      nb_heure_chaleur: varietyData.nb_heure_chaleur,
    };

    api
      .post("/varieties/add-varieties", data)
      .then((response) => {
        if (response && response.data.type === "success") {
          swal(`${t("crop_variety_added")}`, { icon: "success" });
          setToggle(false);
          getVarieties();
        }
        if (response && response.data.type === "danger") {
          swal(`${t("error")}`, { icon: "error" });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleEdit = (varietyId) => {
    const initDays = parseFloat(varietyData.init) || 0;
    const devDays = parseFloat(varietyData.dev) || 0;
    const midDays = parseFloat(varietyData.mid) || 0;
    const lateDays = parseFloat(varietyData.late) || 0;

    const totalDays = initDays + devDays + midDays + lateDays;

    // Check if total days exceed 365
    if (totalDays > 365) {
      swal(t("error"), t("total_stage_days_error"), "error");
      return; // Stop submission
    }
    const datePattern = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])$/;
    if (!displayDate || !datePattern.test(displayDate)) {
      toast.error(t("invalid_date_format"));
      return;
    }
    setIsSaving(true);
    const areKcAndPeriodsValid = [
      varietyData.init,
      varietyData.dev,
      varietyData.mid,
      varietyData.late,
      varietyData.kcInit,
      varietyData.kcMid,
      varietyData.kcLate,
    ].every((val) => val !== "" && !isNaN(parseFloat(val)));
    let data = {
      variety_id: varietyId,
      crop_variety: varietyData.cropVariety,
      init: varietyData.init,
      dev: varietyData.dev,
      mid: varietyData.mid,
      late: varietyData.late,
      kc_init: varietyData.kcInit,
      plant_date: varietyData.plant_date,
      kc_mid: varietyData.kcMid,
      kc_late: varietyData.kcLate,
      root_max: varietyData.rootMax,
      root_min: varietyData.rootMin,
      all_kc: areKcAndPeriodsValid ? resultCalculKc : [],
      temperature_chaleur: varietyData.temperature_chaleur,
      temperature_froid: varietyData.temperature_froid,
      nb_heure_froid: varietyData.nb_heure_froid,
      nb_heure_chaleur: varietyData.nb_heure_chaleur,
    };

    api
      .post("/varieties/edit-variety", data)
      .then((response) => {
        if (response.data.type === "success") {
          const recalculation = response.data.recalculation_message;
          const successIds = recalculation.successfulFields || [];
          const failedIds = recalculation.failedFields || [];

          // Combine all IDs to fetch field names
          const allIds = [...new Set([...successIds, ...failedIds])];

          if (allIds.length === 0) {
            swal({
              title: t("Updated_Variety"),
              text: t("No_Fields_Recalculation"),
              icon: "success",
              button: "OK",
            });
            setToggleEdit(false);
            getVarieties();
            setIsSaving(false);
            return;
          }

          // Fetch names from your new API
          api
            .post("/fields/by-ids", { fieldIds: allIds })
            .then((fieldsRes) => {
              const fieldMap = {};

              if (
                fieldsRes.data &&
                fieldsRes.data.type === "success" &&
                Array.isArray(fieldsRes.data.fields)
              ) {
                fieldsRes.data.fields.forEach((field) => {
                  fieldMap[field.id] = field.name || `Field ${field.id}`;
                });
              }
              // Extract only visible (i.e., returned) field IDs
              const visibleIds = Object.keys(fieldMap).map((id) =>
                parseInt(id)
              );

              // Filter visible success/failure
              const visibleSuccess = successIds.filter((id) =>
                visibleIds.includes(id)
              );
              const visibleFailed = failedIds.filter((id) =>
                visibleIds.includes(id)
              );

              const skippedIds = allIds.filter(
                (id) => !visibleIds.includes(id)
              );

              const rows = [
                ...visibleSuccess,
                ...visibleFailed,
                ...skippedIds,
              ].map((id, index) => ({
                id: index + 1,
                fieldId: id,
                name: fieldMap[id] || `ID: ${id}`,
                status: visibleSuccess.includes(id)
                  ? "✅ " + t("Success")
                  : visibleFailed.includes(id)
                  ? "❌ " + t("Error")
                  : "⚠️ " + t("Deleted"),
              }));

              setFieldRows(rows);
              setToggleEdit(false);
              setOpenDialog(true);
              getVarieties();
              setIsSaving(false);
            })
            .catch((err) => {
              console.error("❌ Failed to fetch field names", err);
              swal(t("variety_updated_but_failed_to_fetch_fields"), {
                icon: "warning",
              });
              setToggleEdit(false);
              getVarieties();
              setIsSaving(false);
            });
        }
        if (response.data.type && response.data.type == "danger") {
          swal({
            icon: "error",
            title: t("Oops..."),
            text: t("error_edit_variety"),
          });
          return false;
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: t("Oops..."),
          text: t("error_edit_variety"),
        });
        setIsSaving(false);
      });
  };

  const handleDelete = async (varietyId) => {
    let data = {
      variety_id: varietyId,
    };
    return await api
      .delete("/varieties/delete-variety", { data: data })
      .then((response) => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: t("cannot_delete_variety"),
            icon: "warning",
          });
          return false;
        }
        if (response.data.type == "success") {
          getVarieties();
          return true;
        }
        return false;
      })
      .catch((error) => {
        swal({
          title: t("cannot_delete_variety"),
          icon: "error",
          text: t("error_delete_variety"),
        });
        return false;
      });
  };

  const confirmDelete = (cropId) => {
    swal({
      title: t("Are_You_Sure"),
      text: t("Delete_Warning"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (Delete) => {
        if (Delete) {
          const deleted = await handleDelete(cropId);
          if (deleted) {
            swal(t("Variety_Deleted"), {
              icon: "success",
            });
          }
        }
      })
      .catch((error) => {
        swal({
          title: t("Cannot_Delete_Variety"),
          text: t("Error_Delete_Variety"),
          icon: "error",
        });
      });
  };

  const filteredCrops = allVarieties.filter((cropsVariety) => {
    if (SearchName !== "") {
      return cropsVariety.crop_variety
        .toLowerCase()
        .includes(SearchName.toLowerCase());
    }

    return cropsVariety;
  });

  const indexOfLastPost = currentPage * cropsPerPage;
  const indexOfFirstPost = indexOfLastPost - cropsPerPage;
  const sortedVarieties = [...filteredCrops].sort((a, b) => {
    const cropA =
      allCrops.find((crop) => crop.id === a.crop_id)?.crop?.toLowerCase() || "";
    const cropB =
      allCrops.find((crop) => crop.id === b.crop_id)?.crop?.toLowerCase() || "";
    return cropA.localeCompare(cropB);
  });

  const currentVarieties = sortedVarieties.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const onChangeHandler = async (e, idx) => {
    //modifier le setResultCalculKc pour ensuite ajouter le resultCalculKc dans l'action save pour inserer un objet clé (1,2,3..) valeur (kc dans le tableau html) dans la base de données colonne kc par jour
    // setResultCalculKc(state => ([...state ,{['day'] : day ,  ['kc'] : value }]), [])
    const value = e.target.value;
    const clone = [...varietyData.allKcList];
    clone[idx] = { ...clone[idx], kc: value };

    setVarietyData((prev) => ({
      ...prev,
      allKcList: clone,
    }));

    setResultCalculKc(clone);
  };

  useEffect(() => {
    if (
      varietyData.init &&
      varietyData.dev &&
      varietyData.mid &&
      varietyData.late &&
      varietyData.kcInit &&
      varietyData.kcMid &&
      varietyData.kcLate
    ) {
      const { results } = tableConfigKc();
      setResultCalculKc(results);
      setVarietyData((prev) => ({
        ...prev,
        allKcList: results,
      }));
    } else {
      setVarietyData((prev) => ({
        ...prev,
        allKcList: [],
      }));
    }
  }, [
    varietyData.init,
    varietyData.dev,
    varietyData.mid,
    varietyData.late,
    varietyData.kcInit,
    varietyData.kcMid,
    varietyData.kcLate,
  ]);

  const tableConfigKc = () => {
    let elements = [];
    let results = [];

    const init = parseInt(varietyData.init);
    const dev = parseInt(varietyData.dev);
    const mid = parseInt(varietyData.mid);
    const late = parseInt(varietyData.late);

    const kcInit = parseFloat(varietyData.kcInit);
    const kcMid = parseFloat(varietyData.kcMid);

    const kcLate = parseFloat(varietyData.kcLate);

    let totalDays = init + dev + mid + late;

    for (let day = 1; day <= totalDays; day++) {
      let kc = 0;

      if (day <= init) {
        kc = kcInit;
      } else if (day <= init + dev) {
        const j = day - init;
        kc = kcInit + ((kcMid - kcInit) / dev) * j;
      } else if (day <= init + dev + mid) {
        kc = kcMid;
      } else if (day <= init + dev + mid + late) {
        const j = day - (init + dev + mid);
        kc = kcMid - ((kcMid - kcLate) / late) * j;
      } else {
        kc = kcLate;
      }

      kc = parseFloat(kc.toFixed(2));
      results.push({ day, kc });

      elements.push(
        <tr key={day}>
          <td>{day}</td>

          <td>
            <input
              name={`kc-${day}`}
              value={kc}
              onChange={(e) => onChangeHandler(e, day - 1)}
              className="my-1"
            />
          </td>
        </tr>
      );
    }

    return { elements, results };
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [SearchName]);

  const handleStageChange = (field, value) => {
    const updatedData = { ...varietyData, [field]: value };
    const total =
      parseInt(updatedData.init || 0) +
      parseInt(updatedData.dev || 0) +
      parseInt(updatedData.mid || 0) +
      parseInt(updatedData.late || 0);

    if (total > 365) {
      setDaysWarning(
        "Total duration of all stages should not exceed 365 days."
      );
    } else {
      setDaysWarning(""); // Clear warning
    }

    setVarietyData(updatedData);
  };
  // Ajoutez ceci avec vos autres useEffect
  useEffect(() => {
    if (varietyData.plant_date) {
      // Si plant_date est au format YYYY-MM-DD
      if (varietyData.plant_date.includes("-")) {
        const parts = varietyData.plant_date.split("-");
        if (parts.length === 3) {
          const [year, month, day] = parts;
          setDisplayDate(`${day}/${month}`);
        }
      }
      // Si plant_date est déjà au format JJ/MM
      else if (varietyData.plant_date.includes("/")) {
        setDisplayDate(varietyData.plant_date);
      }
    } else {
      setDisplayDate("");
    }
  }, [varietyData.plant_date]);

  return (
    <>
      <Container className="management-page admin-management-page configuration-management-page p-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={t("Crops_Varieties_Configuration")}
            subtitle={t("Crops_Varieties_Configuration")}
            className="text-sm-left"
          />
        </Row>
        <Row>
          <PageTitle sm="4" subtitle={t("search")} className="text-sm-left" />
        </Row>
        <Row form className="d-flex justify-content-center">
          <Col md="3" className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  id="search"
                  placeholder={t("search_by_name")}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <PageTitle
            sm="4"
            subtitle={t("my_actions")}
            className="text-sm-left"
          />
        </Row>
        <Row form className="py-2 d-flex justify-content-center">
          <ButtonGroup>
            <Button
              variant="outline-primary"
              onClick={() => {
                setVarietyData({
                  crop: "",
                  cropVariety: "",
                  varietyAr: "",
                  varietyEn: "",
                  kcInit: "",
                  kcMid: "",
                  kcLate: "",
                  init: "",
                  dev: "",
                  mid: "",
                  late: "",
                  rootMin: "",
                  rootMax: "",
                  allKcList: [],
                });
                setToggle(true);
              }}
            >
              {t("Add_Variety")}
            </Button>
          </ButtonGroup>
        </Row>
        <Card>
          <Card.Header className="border-bottom">
            <div>
              <h5>{t("Crops_Varieties_Info")}</h5>
            </div>
          </Card.Header>
          <Card.Body>
            <table className="table mb-0 text-center  table-responsive-lg">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    {t("Crop")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("crop_variety")}
                  </th>
                  <th scope="col" className="border-0"></th>
                </tr>
              </thead>
              <tbody>
                {currentVarieties.map((crop) => {
                  let cropName = "";
                  allCrops.map((crops) => {
                    if (crop.crop_id === crops.id) {
                      cropName = crops.crop;
                    }
                  });

                  return (
                    <tr>
                      <td>{cropName}</td>
                      <td>{crop.crop_variety}</td>
                      <td>
                        <ButtonGroup size="sm" className="mr-2 configuration-action-group">
                          <Button
                            title={t('edit')}
                            onClick={() => {
                              getSingleVariety(crop.id, "Edit");
                            }}
                            className="configuration-action-button"
                          >
                            <i className="fas fa-pen" aria-hidden="true" />
                          </Button>
                          <Button
                            title={t('delete')}
                            onClick={() => {
                              confirmDelete(crop.id);
                            }}
                            className="configuration-action-button"
                            variant="danger"
                          >
                            <i className="fas fa-trash" aria-hidden="true" />
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card.Body>
        </Card>
        <Row className="py-4 justify-content-center">
          <Pagination
            usersPerPage={cropsPerPage}
            totalUsers={filteredCrops.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </Row>
      </Container>
      <Modal
        size="lg"
        className="custom-modal-height"
        centered={true}
        show={toggle}
        onHide={() => setToggle(false)}
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                addVarieties();
              }}
              className="mb-2 mr-1 btn btn-success"
            >
              <i className="fa fa-check mx-2"></i>
              {t("save")}
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              onClick={() => {
                setToggle(false);
                setDaysWarning("");
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="gap-2">
            <Col lg="7" md="12" sm="12" className="border-right">
              <Card.Body>
                <Row className="gap-2">
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="crop">{t("Crop_Type")}</label>
                      <Form.Select
                        id="crop"
                        placeholder={t("Crop_Type")}
                        value={varietyData.crop || ""}
                        onChange={(e) =>
                          setVarietyData({
                            ...varietyData,
                            crop: e.target.value,
                          })
                        }
                      >
                        <option value="">{t("Crop_Type")}</option>
                        {allCrops.map((crop) => {
                          return <option value={crop.id}>{crop.crop}</option>;
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group className="d-flex justify-content-center  flex-column">
                      <label htmlFor="type">{t("Variety_Type")}</label>

                      <Form.Control
                        id="type"
                        style={{ height: "40px" }}
                        value={varietyData.cropVariety}
                        placeholder={t("Variety_name")}
                        onChange={(e) =>
                          setVarietyData({
                            ...varietyData,
                            cropVariety: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="gap-2 mt-4">
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="temperature_chaleur">
                        {t("Température_de_chaleur")}
                      </label>
                      <Form.Control
                        id="temperature_chaleur"
                        type="number"
                        placeholder={t("Température_de_chaleur")}
                        value={varietyData.temperature_chaleur || ""}
                        onChange={(e) =>
                          setVarietyData({
                            ...varietyData,
                            temperature_chaleur: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="temperature_froid">
                        {t("Température_de_froid")}
                      </label>
                      <Form.Control
                        id="temperature_froid"
                        type="number"
                        placeholder={t("Température_de_froid")}
                        value={varietyData.temperature_froid || ""}
                        onChange={(e) =>
                          setVarietyData({
                            ...varietyData,
                            temperature_froid: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="gap-2 mt-4">
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="nb_heure_froid">
                        {t("Nombre_d’heure_de_froid")}
                      </label>
                      <Form.Control
                        id="nb_heure_froid"
                        type="number"
                        placeholder={t("Nombre_d’heure_de_froid")}
                        value={varietyData.nb_heure_froid || ""}
                        onChange={(e) =>
                          setVarietyData({
                            ...varietyData,
                            nb_heure_froid: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="nb_heure_chaleur">
                        {t("Nombre_d’heure_de_chaleur")}
                      </label>
                      <Form.Control
                        id="nb_heure_chaleur"
                        type="number"
                        placeholder={t("Nombre_d’heure_de_chaleur")}
                        value={varietyData.nb_heure_chaleur || ""}
                        onChange={(e) =>
                          setVarietyData({
                            ...varietyData,
                            nb_heure_chaleur: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Col>

            <Col lg="4" md="12" sm="12" className="">
              <Form.Group>
                <label htmlFor="plantDate">{t("Start_season_Date")}</label>
                <Form.Control
                  id="plantDate"
                  placeholder={t("dd/MM")}
                  type="text"
                  value={displayDate}
                  onChange={(e) => {
                    let input = e.target.value.replace(/\D/g, "");

                    // Validation du jour (max 31)
                    if (input.length >= 2) {
                      let day = parseInt(input.substring(0, 2));
                      if (day > 31) day = 31;
                      if (day < 1 && input.length === 2) day = 1;
                      input =
                        day.toString().padStart(2, "0") + input.substring(2);
                    }

                    // Validation du mois (max 12)
                    if (input.length >= 4) {
                      let month = parseInt(input.substring(2, 4));
                      if (month > 12) month = 12;
                      if (month < 1) month = 1;
                      input =
                        input.substring(0, 2) +
                        month.toString().padStart(2, "0");
                    }

                    // Formatage avec /
                    let formatted = input;
                    if (input.length >= 2) {
                      formatted =
                        input.substring(0, 2) + "/" + input.substring(2, 4);
                    }

                    formatted = formatted.substring(0, 5);
                    setDisplayDate(formatted);

                    // Si on a JJ/MM complet, on reconstruit la date complète
                    if (input.length === 4) {
                      const day = input.substring(0, 2);
                      const month = input.substring(2, 4);
                      const year = new Date().getFullYear();

                      setVarietyData({
                        ...varietyData,
                        plant_date: `${year}-${month}-${day}`,
                      });
                    } else {
                      // Si la date n'est pas complète, on vide plant_date
                      setVarietyData({
                        ...varietyData,
                        plant_date: "",
                      });
                    }
                  }}
                  maxLength={5}
                />
              </Form.Group>
              <h6 className="mt-2">Kc</h6>
              <div className="d-flex justify-content-center align-items-center">
                <Form.Control
                  placeholder="kc_init"
                  className="m-1"
                  value={varietyData.kcInit}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, kcInit: e.target.value })
                  }
                />

                <Form.Control
                  placeholder="kc_mid"
                  className="m-1"
                  value={varietyData.kcMid}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, kcMid: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="kc_late"
                  value={varietyData.kcLate}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, kcLate: e.target.value })
                  }
                />
              </div>
              <h6>{t("Stage(Days)")}</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Init"
                  className="m-1"
                  value={varietyData.init}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, init: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("init", e.target.value)}
                />
                <Form.Control
                  placeholder="Dev"
                  value={varietyData.dev}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, dev: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("dev", e.target.value)}
                />
                <Form.Control
                  placeholder="Mid"
                  className="m-1"
                  value={varietyData.mid}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, mid: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("mid", e.target.value)}
                />
                <Form.Control
                  placeholder="Late"
                  value={varietyData.late}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, late: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("late", e.target.value)}
                />
              </div>
              <h6>{t("roots")}</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Min"
                  className="m-1"
                  value={varietyData.rootMin}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, rootMin: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="Max"
                  value={varietyData.rootMax}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, rootMax: e.target.value })
                  }
                />
              </div>

              {daysWarning && (
                <small
                  style={{
                    color: "red",
                    marginTop: "5px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  {daysWarning}
                </small>
              )}
            </Col>
          </Row>
          <Row>
            {varietyData.allKcList && varietyData.allKcList.length > 0 && (
              <Col lg="12" md="12" sm="12" className="mt-1">
                <Line data={chartData} options={chartOptions} />
              </Col>
            )}
          </Row>
          <Row className="border-top mt-2">
            {varietyData.allKcList && varietyData.allKcList.length > 0 && (
              <Col lg="12" sm="12" md="12">
                <table className="table mb-0 border text-center  table-responsive">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0">
                        {t("Day")}
                      </th>

                      <th scope="col" className="border-0">
                        {t("Kc")}
                      </th>
                    </tr>
                  </thead>

                  {varietyData.allKcList &&
                    varietyData.allKcList.map((result, indx) => (
                      <tr key={result.day}>
                        <td>{result.day}</td>

                        <td>
                          <input
                            name={`kc-${result.day}`}
                            className="my-1"
                            value={result.kc}
                            onChange={(e) => onChangeHandler(e, indx)}
                          />
                        </td>
                      </tr>
                    ))}
                </table>
              </Col>
            )}
          </Row>
          <ToastContainer
            position="top-center" // <-- centre horizontal
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
      <Modal
        className="custom-modal-height"
        size="lg"
        centered={true}
        show={toggleEdit}
        onHide={() => setToggleEdit(false)}
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                handleEdit(singleCrop.id);
              }}
              className="mb-2 mr-1 btn btn-success"
              disabled={isSaving}
            >
              {/* <i className="fa fa-check mx-2"></i> */}

              {isSaving ? (
                <>
                  <CircularProgress
                    size={20}
                    color="inherit"
                    style={{ marginRight: 8 }}
                  />
                  {t("Saving...")}
                </>
              ) : (
                t("save")
              )}
            </Button>

            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              disabled={isSaving}
              onClick={() => {
                setToggleEdit(false);
                setDaysWarning("");
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="gap-2">
            <Col lg="7" md="12" sm="12" className="border-right">
              <Card.Body>
                <Row className="gap-2">
                  <Row className="gap-2 mt-2 mb-2">
                    <Col lg="5" md="12" sm="12">
                      <Form.Group className="">
                        <label htmlFor="type" className="">
                          {t("Variety_Type")}
                        </label>

                        <Form.Control
                          id="type"
                          value={varietyData.cropVariety}
                          onChange={(e) =>
                            setVarietyData({
                              ...varietyData,
                              cropVariety: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="5" md="12" sm="12">
                      <Form.Group>
                        <label htmlFor="Varietyar">
                          {t("Variety_Type")} (Ar)
                        </label>
                        <Form.Control
                          id="Varietyar"
                          placeholder={t("Variety_Type")}
                          value={varietyData.varietyAr}
                          onChange={(e) =>
                            setVarietyData({
                              ...varietyData,
                              varietyAr: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="gap-2">
                    <Col lg="5" md="12" sm="12">
                      <Form.Group>
                        <label htmlFor="Varietyen">
                          {t("Variety_Type")} (En)
                        </label>
                        <Form.Control
                          id="Varietyen"
                          placeholder={t("Variety_Type")}
                          value={varietyData.varietyEn}
                          onChange={(e) =>
                            setVarietyData({
                              ...varietyData,
                              varietyEn: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="5" md="12" sm="12">
                      <Form.Group>
                        <label htmlFor="plantDate">
                          {t("Start_season_Date")}
                        </label>
                        <Form.Control
                          id="plantDate"
                          placeholder={t("dd/MM")}
                          type="text"
                          value={displayDate}
                          onChange={(e) => {
                            let input = e.target.value.replace(/\D/g, "");

                            // Validation du jour (max 31)
                            if (input.length >= 2) {
                              let day = parseInt(input.substring(0, 2));
                              if (day > 31) day = 31;
                              if (day < 1 && input.length === 2) day = 1;
                              input =
                                day.toString().padStart(2, "0") +
                                input.substring(2);
                            }

                            // Validation du mois (max 12)
                            if (input.length >= 4) {
                              let month = parseInt(input.substring(2, 4));
                              if (month > 12) month = 12;
                              if (month < 1) month = 1;
                              input =
                                input.substring(0, 2) +
                                month.toString().padStart(2, "0");
                            }

                            // Formatage avec /
                            let formatted = input;
                            if (input.length >= 2) {
                              formatted =
                                input.substring(0, 2) +
                                "/" +
                                input.substring(2, 4);
                            }

                            formatted = formatted.substring(0, 5);
                            setDisplayDate(formatted);

                            // Si on a JJ/MM complet, on reconstruit la date complète
                            if (input.length === 4) {
                              const day = input.substring(0, 2);
                              const month = input.substring(2, 4);
                              const year = new Date().getFullYear();

                              setVarietyData({
                                ...varietyData,
                                plant_date: `${year}-${month}-${day}`,
                              });
                            }
                          }}
                          maxLength={5}
                        />
                        {/* <div className="invalid-feedback">{plantDateErr}</div> */}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="gap-2">
                    <Col lg="5" md="12" sm="12">
                      <Form.Group>
                        <label htmlFor="temperature_chaleur">
                          {t("Température_de_chaleur")}
                        </label>
                        <Form.Control
                          id="temperature_chaleur"
                          type="number"
                          placeholder={t("Température_de_chaleur")}
                          value={varietyData.temperature_chaleur || ""}
                          onChange={(e) =>
                            setVarietyData({
                              ...varietyData,
                              temperature_chaleur: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col lg="5" md="12" sm="12">
                      <Form.Group>
                        <label htmlFor="temperature_froid">
                          {t("Température_de_froid")}
                        </label>
                        <Form.Control
                          id="temperature_froid"
                          type="number"
                          placeholder={t("Température_de_froid")}
                          value={varietyData.temperature_froid || ""}
                          onChange={(e) =>
                            setVarietyData({
                              ...varietyData,
                              temperature_froid: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="gap-2 mt-2">
                    <Col lg="5" md="12" sm="12">
                      <Form.Group>
                        <label htmlFor="nb_heure_froid">
                          {t("Nombre_d’heure_de_froid")}
                        </label>
                        <Form.Control
                          id="nb_heure_froid"
                          type="number"
                          placeholder={t("Nombre_d’heure_de_froid")}
                          value={varietyData.nb_heure_froid || ""}
                          onChange={(e) =>
                            setVarietyData({
                              ...varietyData,
                              nb_heure_froid: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col lg="5" md="12" sm="12">
                      <Form.Group>
                        <label htmlFor="nb_heure_chaleur">
                          {t("Nombre_d’heure_de_chaleur")}
                        </label>
                        <Form.Control
                          id="nb_heure_chaleur"
                          type="number"
                          placeholder={t("Nombre_d’heure_de_chaleur")}
                          value={varietyData.nb_heure_chaleur || ""}
                          onChange={(e) =>
                            setVarietyData({
                              ...varietyData,
                              nb_heure_chaleur: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Row>
              </Card.Body>
            </Col>

            <Col lg="4" md="12" sm="12" className="">
              <h6>Kc</h6>
              <div className="d-flex justify-content-center align-items-center">
                <Form.Control
                  placeholder="kc-init"
                  className="m-1"
                  value={varietyData.kcInit}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, kcInit: e.target.value })
                  }
                />

                <Form.Control
                  placeholder="kc_mid"
                  className="m-1"
                  value={varietyData.kcMid}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, kcMid: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="kc_late"
                  value={varietyData.kcLate}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, kcLate: e.target.value })
                  }
                />
              </div>
              <h6> {t("Stage(Days)")}</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Init"
                  className="m-1"
                  value={varietyData.init}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, init: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("init", e.target.value)}
                />
                <Form.Control
                  placeholder="Dev"
                  value={varietyData.dev}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, dev: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("dev", e.target.value)}
                />
                <Form.Control
                  placeholder="Mid"
                  className="m-1"
                  value={varietyData.mid}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, mid: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("mid", e.target.value)}
                />
                <Form.Control
                  placeholder="Late"
                  value={varietyData.late}
                  // onChange={(e) => {
                  //   setVarietyData({ ...varietyData, late: e.target.value });
                  //   checkTotalDays();
                  // }}
                  onChange={(e) => handleStageChange("late", e.target.value)}
                />
              </div>
              {daysWarning && (
                <small
                  style={{
                    color: "red",
                    marginTop: "5px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  {daysWarning}
                </small>
              )}
              <h6>{t("roots")}</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Min"
                  className="m-1"
                  value={varietyData.rootMin}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, rootMin: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="Max"
                  value={varietyData.rootMax}
                  onChange={(e) =>
                    setVarietyData({ ...varietyData, rootMax: e.target.value })
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            {/* {varietyData.allKcList && varietyData.allKcList.length > 0 && 
            <Col lg="12" md="12" sm="12" className="mt-1">
              <Line data={chartData} options={chartOptions} />
            </Col>
          
            
            } */}

            <Col lg="12" md="12" sm="12" className=" p-2">
              <div
                style={{ position: "relative", minHeight: "400px" }}
                className="mb-5"
              >
                <div
                  style={{
                    filter:
                      varietyData.allKcList && varietyData.allKcList.length > 0
                        ? "none"
                        : "blur(1px)",
                    transition: "filter 0.3s ease",
                    boxShadow: "0 2px 2px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    padding: "1rem",
                  }}
                >
                  <Line data={chartData} options={chartOptions} />
                </div>

                {(!varietyData.allKcList ||
                  varietyData.allKcList.length === 0) && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      pointerEvents: "none",
                      padding: "2rem",
                      textAlign: "center",
                      color: "#b83d53",
                      fontWeight: "700",
                      fontSize: "1rem",

                      borderRadius: "8px",
                    }}
                  >
                    {t("please_provide_kc_values_chart")}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row className="border-top mt-2">
            <Col lg="12" md="12" sm="12" className="mt-1">
              {/* <button onClick={() => tableConfigKc()}>Calculer</button> */}
              <div
                style={{ position: "relative", minHeight: "300px" }}
                className="mb-4"
              >
                <div
                  style={{
                    filter:
                      varietyData.allKcList && varietyData.allKcList.length > 0
                        ? "none"
                        : "blur(1px)",
                    transition: "filter 0.3s ease",
                    boxShadow: "0 2px 2px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    padding: "1rem",
                    overflowX: "auto",
                  }}
                ></div>
                <table className="table mb-0 border text-center  table-responsive">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0">
                        {t("Day")}
                      </th>

                      <th scope="col" className="border-0">
                        {t("Kc")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {varietyData.allKcList &&
                      varietyData.allKcList?.map((result, indx) => {
                        return (
                          <tr>
                            <td>{result.day}</td>

                            <td>
                              <input
                                name={indx}
                                key={indx}
                                className="my-1"
                                value={result.kc}
                                onChange={(e) => onChangeHandler(e, indx)}
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                {(!varietyData.allKcList ||
                  varietyData.allKcList.length === 0) && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      pointerEvents: "none",
                      padding: "2rem",
                      textAlign: "center",
                      color: "#b83d53",
                      fontWeight: "700",
                      fontSize: "1rem",
                      borderRadius: "8px",
                    }}
                  >
                    {t("please_enter_kc_stages_first")}
                  </div>
                )}
              </div>
              <div className="mt-4"></div>
            </Col>
            <ToastContainer
              position="top-center" // <-- centre horizontal
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Row>
        </Modal.Body>
      </Modal>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{t("Field Recalculation Report")}</DialogTitle>
        <DialogContent>
          <div style={{ height: 500, width: "100%" }}>
            <DataGrid
              rows={fieldRows}
              columns={columns}
              initialState={{
                pagination: { paginationModel: { page: 0, pageSize: 5 } },
              }}
              pageSizeOptions={[5, 10]}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ConfigurationCropsVariety;
